import type { RouteObject } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';
import NotFound from '@/pages/NotFound';
import Home from '@/pages/home/page';
import Feed from '@/pages/feed/page';
import Article from '@/pages/article/page';
import About from '@/pages/about/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: 'feed', element: <Feed /> },
      { path: 'article/:slug', element: <Article /> },
      { path: 'about', element: <About /> },
      { path: '*', element: <NotFound /> },
    ],
  },
];

export default routes;